import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';
import { TestimonialCard } from '../../components/footer/TestimonialCard';
import { CTASection } from '../../components/footer/CTASection';

export const CaregiverStoriesPage: React.FC = () => {
  const theme = useTheme();

  const testimonials = [
    {
      name: "Sarah Martinez",
      role: "Physical Therapist",
      location: "Austin, TX",
      rating: 5,
      text: "Since joining Careva, I've been able to set my own schedule and focus on the patients I want to work with. The platform handles all the administrative work, so I can focus on what I love - helping people heal.",
      service: "Physical Therapy",
    },
    {
      name: "Michael Rodriguez",
      role: "Occupational Therapist",
      location: "Seattle, WA",
      rating: 5,
      text: "As a single parent, I needed flexibility in my schedule. Careva allows me to work around my children's needs while still providing quality care to my patients. It's been a game-changer.",
      service: "Occupational Therapy",
    },
    {
      name: "Jennifer Chen",
      role: "Registered Nurse",
      location: "Miami, FL",
      rating: 5,
      text: "The earning potential on Careva is incredible. I've doubled my income while working fewer hours. The patients are amazing, and the support team is always there when I need help.",
      service: "Home Health Care",
    },
  ];

  return (
    <PageLayout
      title="Caregiver Stories"
      subtitle="Hear from healthcare professionals who have built successful practices and found fulfillment through our platform."
      breadcrumbs={[
        { label: "For Caregivers", href: "/for-caregivers" },
        { label: "Caregiver Stories" },
      ]}
    >
      {/* Testimonials */}
      <ContentSection
        title="What Our Caregivers Say"
        subtitle="Real stories from healthcare professionals who have found success and fulfillment through our platform."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={4}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <TestimonialCard {...testimonial} />
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* CTA Section */}
      <CTASection
        title="Ready to Start Your Story?"
        subtitle="Join our network of healthcare professionals and start building your successful practice today."
        primaryButton={{
          text: "Apply Now",
          href: "/auth?role=caregiver",
        }}
        secondaryButton={{
          text: "Learn More",
          href: "/become-caregiver",
          variant: "outlined",
        }}
      />
    </PageLayout>
  );
};
